module.exports = __webpack_public_path__ + "img/mail-outline-black.efda6afe.svg";